import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { getCaption } from '@alfa-bank/site-form-helpers/meta/get-caption';
import { isError } from '@alfa-bank/site-form-helpers/meta/is-error';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';

import { EmailField } from './email-field';
import { validateEmail, isSuccess } from './helpers';
import type { TEmail, IDeps } from './models';
import { Email as Component } from './email';

export const Email = createWidget<IDeps, TEmail>({
    Field,
    EmailField,
    getCaption,
    isError,
    isSuccess,
    validateEmail,
})(Component);
